import { Button } from "@/components/ui/button";
import { getUserRoles } from '@/utils/auth';
import { ArrowLeft } from "lucide-react";
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CSAWPrintTemplate } from './PrintCertificateTemplates/CSAWPrintTemplate';

const CSAWCertificatePrintPage = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const certificate = location.state?.certificate;
   const orderOfPayment = location.state?.orderOfPayment;

   useEffect(() => {
      if (!certificate || !certificate.csawCertificateData) {
         console.error('Invalid certificate data:', certificate);
         toast.error('Invalid certificate data');
         navigate('/personnel/dashboard');
         return;
      }
   }, [certificate, navigate]);

   let check = 0;
   useEffect(() => {
      check++;
      if (location.pathname === '/personnel/csaw-certificate-print') {
         if (check === 1) {
            toast.info('Please wait while we print your certificate...', { duration: 3000, position: 'top-center' });
         }
         if (check === 1) {
            setTimeout(() => {
               window.print();
            }, 3500);
         }
      } else {
         toast.error('Invalid URL');
         navigate('/personnel/dashboard');
      }
   }, [location.pathname]);

   const handleBack = () => {
      const userRoles = getUserRoles();
      if (userRoles.includes('Technical_Staff')) {
         navigate("/personnel/technical-staff");
      } else {
         navigate("/personnel/dashboard");
      }
   };

   if (!certificate || !certificate.csawCertificateData) return null;

   return (
      <div className="print-page bg-white min-h-screen">
         {/* Back Button - will be hidden during print */}
         <div className="fixed top-4 left-4 no-print">
            <Button
               variant="outline"
               onClick={handleBack}
               className="flex items-center gap-2"
            >
               <ArrowLeft className="h-4 w-4" />
               Back
            </Button>
         </div>

         <div
            className="print-content"
            dangerouslySetInnerHTML={{
               __html: CSAWPrintTemplate({ certificate, orderOfPayment })
            }}
         />

         <style>
            {`
              @media print {
                @page {
                  size: A4;
                  margin: 15mm;
                }
                .no-print {
                  display: none !important;
                }
                .print-content {
                  padding: 0;
                  margin: 0;
               }
                body {
                  margin: 0;
                  padding: 0;
                }
              }
            `}
         </style>
      </div>
   );
};

export default CSAWCertificatePrintPage;
